"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LearningPath/components/Accordion.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Li_template = require("./Li.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Li_tag = marko_loadTag(Li_template),
    Card_Accordion_template = require("../../../components/Card-Accordion/index.marko"),
    Card_Accordion_tag = marko_loadTag(Card_Accordion_template),
    marko_attrs0 = {
        "class": "ml-6 border-left",
        style: "padding-left:3em"
      },
    marko_attrs1 = {
        "class": "list-unstyled"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Card_Accordion_tag({
      type: "learning-path",
      target: "course-about-content",
      title: "Introduction to software engineer",
      image: "/images/slider/10.png",
      class: "p-0",
      caption: {
          label: "12 Courses",
          time: "36 Hours",
          completed: input.completed
        },
      noCollapseIcon: true,
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("ul", marko_attrs1, "2", component);

        Li_tag({
            number: 1,
            title: "Arithmetics",
            image: "/images/slider/11.png",
            time: "6 Hours"
          }, out, __component, "3");

        Li_tag({
            number: 2,
            title: "Binary Sequences",
            image: "/images/slider/10.png",
            time: "8 Hours"
          }, out, __component, "4");

        Li_tag({
            number: 3,
            title: "Assembly Programming",
            image: "/images/slider/09.png",
            time: "5 Hours"
          }, out, __component, "5");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
